module.exports = __webpack_public_path__ + "img/胡金泉.406a6820.png";